<template>
  <div class="container-fluid page-internal-products">
    <div class="row pt-4">
      <div class="col-6">
        <p class="page-title"><i class="fas fa-box"></i> Internal Products</p>
      </div>
      <div class="col-6">
        <div class="input-group md-form form-sm form-2 pl-0 table-filter">
          <button
            class="btn btn-primary btn-sm mx-1"
            type="button"
            @click="bulkUpdate"
          >
            <i class="fas fa-save" />
            Save changes
          </button>
          <button
            class="btn btn-primary btn-sm mx-1"
            type="button"
            @click="importCompatibles"
          >
            <i class="fas fa-google-drive" />
            Import Compatibles from Google Drive
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm mr-2"
            @click="createNewInternalProduct"
          >
            <i class="fas fa-plus"></i>
          </button>
          <input
            class="col"
            name="query"
            v-model="searchQuery"
            placeholder="Search"
          />
          <div class="input-group-append">
            <span class="input-group-text">
              <i class="fas fa-filter text-grey" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <GridTable
          :data="gridData"
          :columns="gridColumns"
          :filter-key="searchQuery"
          :sortable=true
          @datachange="dataChange($event)"
          @sortData="changePage($event)"
        />
        <b-pagination
          size="sm"
          v-model="page"
          :per-page="100"
          :total-rows="totalRows"
          align="center"
          @change="changePage($event)"
        />
        <ExporterImporterData
          :domains="domains"
          :exportToCAShown="true"
          :exportToShopify="true"
          title="InternalProducts"
          url="/internal-products"
          :filter="searchQuery"
          @ShopifySync="handleShopifySyncData"
          @fileImport="handleImportData"
          @export="handleExportData"
        />
      </div>
    </div>
    <b-modal ref="modal" :title="modal.title" size="xl" ok-only>
      <p style="white-space: pre">{{ modal.content }}</p>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BPagination } from "bootstrap-vue";
import GridTable from "@/components/MarketplacesGrid/MarketplacesGrid.vue";
import ProductsApiRequest from "@/components/ApiRequester/InternalProductBulkUpdate.js";
import ExporterImporterData from "@/components/Common/ImporterExporterData";
import router from "@/router";

const ApiRequest = new ProductsApiRequest();

export default {
  name: "InternalProductsBulkUpdate",
  components: {
    GridTable,
    BPagination,
    BModal,
    ExporterImporterData,
  },
  data() {
    return {
      domains: [{ id: 1, name: "Maxtop" }],
      sorting_order: { 1: 1, 2: 2, 3: 3, 4: 4, 5: 5 },
      modal: {
        title: "",
        content: "",
      },
      searchQuery: "",
      totalRows: 0,
      page: 1,
      sortable: true,
      sortKey: "",
      sortOrders: "",
      gridData: [],
      gridDataBulk: [],
      gridColumns: [
        {
          column: "SKU",
          index: "sku",
          type: "link",
          path: "/internal-products/:id/edit",
          size: "100px",
          align: "left",
          sortable: "sku",
          defaultSort: 1,
        },
        {
          column: "Title",
          index: "title",
          type: "input",
          size: "300px",
          align: "left",
          sortable: "title",
          defaultSort: 1,          
        },
        {
          column: "Category",
          index: "category",
          type: "raw",
          size: "70px",
          align: "left",
          sortable: "category",
          defaultSort: 1,  
        },
        {
          column: "Type",
          index: "type",
          type: "raw",
          size: "70px",
          align: "left",
          sortable: "type",
          defaultSort: 1,  
        },
        {
          column: "Series",
          index: "series",
          type: "raw",
          size: "70px",
          align: "left",
          sortable: "series",
          defaultSort: 1,  
        },
        {
          column: "Brand",
          index: "brand",
          type: "raw",
          size: "65px",
          align: "left",
          sortable: "brand",
          defaultSort: 1,
        },
        {
          column: "UPC",
          index: "upc",
          type: "input",
          size: "100px",
          align: "left",
        },
        {
          column: "MSRP",
          index: "retail_price",
          type: "input",
          size: "65px",
          align: "right",
        },
        {
          column: "WSP",
          index: "wholesale_price",
          type: "input",
          size: "65px",
          align: "right",
        },
        {
          column: "Weight",
          index: "weight",
          type: "raw",
          size: "45px",
          align: "right",
        },
        {
          column: "Order",
          index: "sorting_order",
          type: "select",
          size: "38px",
          align: "left",
          sortable: "order",
          defaultSort: 1,
        },
        {
          column: "Shopify",
          index: "is_shopify",
          type: "checkbox",
          size: "30px",
          align: "left",
        },
        {
          column: "&#9733;",
          index: "recommend_product",
          type: "checkbox",
          size: "30px",
          align: "left",
        },
      ],
    };
  },
  mounted() {
    document.getElementById("loader").classList.add("active");

    ApiRequest.getProducts({ page: this.page })
      .then((response) => {
        const { total, data } = response.data;
        this.totalRows = total;
        const dataObj = Array.isArray(data) ? data : Object.values(data);
        const sorting_order = this.sorting_order;

        dataObj.forEach(function (item, i, arr) {
          arr[i]["sorting_order"] = {
            selected: item.sorting_order,
            options: sorting_order,
          };
        });

        this.gridData = dataObj;
        document.getElementById("loader").classList.remove("active");
      })
      .catch(() => {
        document.getElementById("loader").classList.remove("active");
      });

    ApiRequest.finishCall();
    document.getElementById("loader").classList.remove("active");
  },
  watch: {
    searchQuery(newV) {
      document.getElementById("loader").classList.add("active");

      ApiRequest.cancelPreviousRequest();
      ApiRequest.getProducts({
        filter: newV,
      })
        .then((response) => {
          const { data, total } = response.data;
          const dataObj = Array.isArray(data) ? data : Object.values(data);
          this.totalRows = total;
          const sorting_order = this.sorting_order;

          dataObj.forEach(function (item, i, arr) {
            arr[i]["sorting_order"] = {
              selected: item.sorting_order,
              options: sorting_order,
            };
          });

          this.gridData = dataObj;

          ApiRequest.finishCall();
          document.getElementById("loader").classList.remove("active");
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    },
  },
  methods: {
    arrayToOptions(arr, fields) {
      let obj = {};
      arr.forEach((item) => {
        obj[item[fields.key]] = item[fields.option];
      });
      return obj;
    },
    importCompatibles() {
      document.getElementById("loader").classList.add("active");

      ApiRequest.importFromDrive()
        .then((response) => {
          let errorMessage = "";

          if (response.data.messages.length == 0) {
            errorMessage = "No errors found.";
          } else {
            response.data.messages.forEach((error) => {
              errorMessage += "* " + error + "\n";
            });
          }

          this.modal = Object.assign(
            {},
            {
              title: "Success",
              content: "The file was imported successfully.\n" + errorMessage,
            }
          );

          this.$refs.modal.show();
          document.getElementById("loader").classList.remove("active");
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    },

    changePage(obj) {
      this.gridData = [];
 
      let payload = { page: 1 };            

      if (!isNaN(obj)) {
        payload = { page: obj };
      }

      if (this.searchQuery !== "") {
        payload = Object.assign(payload, {
          filter: this.searchQuery,
        });
      }
      
      if (typeof obj.key !== 'undefined') {
        this.sortKey = obj.key
      }

      if (typeof obj.direction !== 'undefined') {
        this.sortOrders = obj.direction
      }

      payload = Object.assign(payload, {
        sortKey: this.sortKey,
        sortOrders: this.sortOrders,
      });

      document.getElementById("loader").classList.add("active");
      ApiRequest.getProducts(payload)
        .then((response) => {
          const { data, total } = response.data;
          this.totalRows = total;
          const dataObj = Array.isArray(data) ? data : Object.values(data);
          const sorting_order = this.sorting_order;

          dataObj.forEach(function (item, i, arr) {
            arr[i]["sorting_order"] = {
              selected: item.sorting_order,
              options: sorting_order,
            };
          });

          this.gridData = dataObj;

          this.gridDataBulk.forEach((item) => {
            this.gridData.forEach(function (elm, i, arr) {
              if (arr[i]["id"] === item["id"]) {
                arr[i] = item;
              }
            });
          });

          document.getElementById("loader").classList.remove("active");
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    },
    createNewInternalProduct() {
      router.push("/internal-products/create");
    },
    handleImportData(response) {
      switch (response.status) {
        case "success":
          this.modal = Object.assign(
            {},
            {
              title: "Success",
              content: "The file was imported successfully",
            }
          );
          break;
        case "error": {
          this.modal = Object.assign(
            {},
            {
              title: "Error",
            }
          );

          let content = "";

          response.errors.forEach((error) => {
            content += "* " + error + "\n";
          });

          this.modal = Object.assign(this.modal, {
            content: content,
          });
        }
      }

      document.getElementById("loader").classList.add("active");
      ApiRequest.getProducts({
        page: this.page,
        per_page: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;
          this.gridData = data;
          this.totalRows = total;
          this.$refs.modal.show();
          ApiRequest.finishCall();
          document.getElementById("loader").classList.remove("active");
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    },

    handleShopifySyncData(response) {
      let infoMessage = "";  
      if (response.messages.length == 0) {
        infoMessage = "No errors found.";
      } else {
        response.messages.forEach((info) => {
          infoMessage += "* " + info + "\n";
        });
      }

      this.modal = Object.assign(
        {},
        {
          title: "The Shopify was sync successfully",
          content:
            "Total rows: " +
            response.total +
            "\nTotal Shopify rows: " +
            response.shopify +
            "\nSync rows: " +
            response.sync +
            "\nInfo:\n" +
            infoMessage,
        }
      );
      this.$refs.modal.show();
    },

    handleExportData(response) {
      this.modal = Object.assign(
        {},
        {
          title: "Error",
          content: response,
        }
      );

      this.$refs.modal.show();
    },

    dataChange(param) {
      if (param[1] == "category" || param[1] == "type") {
        let seriesFiltered = JSON.parse(JSON.stringify(this.series));

        seriesFiltered = seriesFiltered.filter(
          function (e) {
            return (
              this["type"] === e.internal_product_type_id &&
              this["category"] === e.internal_product_category_id
            );
          },
          {
            type: parseInt(param[0]["type"]["selected"]),
            category: parseInt(param[0]["category"]["selected"]),
          }
        );

        let seriesOptions = {};
        seriesFiltered.forEach((e) => {
          seriesOptions[e["id"]] = e["sku"];
        });

        this.gridData.forEach(function (elm, i, arr) {
          if (arr[i]["id"] === param[0]["id"]) {
            arr[i]["series"] = {
              selected: arr[i]["series"]["selected"],
              options: seriesOptions,
            };
          }
        });
      }

      let addRecord = true;
      this.gridDataBulk.forEach(function (item, i, arr) {
        if (arr[i]["id"] === param[0]["id"]) {
          arr[i] = param[0];
          addRecord = false;
        }
      });

      if (addRecord === true) {
        this.gridDataBulk.push(param[0]);
      }
    },

    bulkUpdate() {
      const bulkData = JSON.parse(JSON.stringify(this.gridDataBulk));
      bulkData.forEach(function (item, i, arr) {
        delete arr[i]["series"];
        arr[i]["sorting_order"] = item.sorting_order.selected;
      });

      document.getElementById("loader").classList.add("active");
      ApiRequest.cancelPreviousRequest();
      ApiRequest.update({
        method: "POST",
        data: {
          page: this.page,
          per_page: this.perPage,
          total_rows: this.totalRows,
          data: bulkData,
        },
      })
        .then((response) => {
          let errorMessage = "";
          if (response.data.messages.length == 0) {
            errorMessage = "No errors found.";
          } else {
            response.data.messages.forEach((error) => {
              errorMessage += "* " + error + "\n";
            });
          }

          this.modal = Object.assign(
            {},
            {
              title: "Success",
              content: "The file was imported successfully.\n" + errorMessage,
            }
          );

          this.$refs.modal.show();
          document.getElementById("loader").classList.remove("active");
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
      ApiRequest.finishCall();
    },
  },
};
</script>
